export const stripHtml = (value: string) => value?.replace(/(<([^>]+)>)/gi, '');
